import { GlobalStyleDefaults } from "manifest-components/src/Styles/globals";
import User from "manifest-components/src/classes/user";
import { SlugValidation } from "manifest-components/src/classes/vendorConfig";
import UserEmployerDetails from "manifest-components/src/classes/userEmployerDetails";
import { StaticDataList } from "manifest-components/src/api/APIUser";
import UserDetails from "manifest-components/src/classes/userDetails";

export const AppState = {
  theme: {
    ...GlobalStyleDefaults,
  },
  userFetched: false,
  fetchingUser: false,
  fetchingUserDetails: false,
  user: {} as User,
  userDetails: {} as UserDetails,
  emailVerified: false,
  emailAddressChanged: false,
  phoneNumberChanged: false,
  countriesList: [] as StaticDataList["staticDataList"],
  countriesListFetched: false,
  suffixList: [] as StaticDataList["staticDataList"],
  suffixListFetched: false,
  statesList: [] as StaticDataList["staticDataList"],
  statesListFetched: false,
  passwordChanged: false,
  showHamburgerMenu: false,
  verificationCodeDeliveryMethod: "",
  vendorName: "",
  showTopBarIcons: { showArrow: true, showHamburger: true },
  showTopBarGradient: true,
  employerInfo: {} as SlugValidation,
  employerInfoFetched: false,
  fetchingEmployerDetails: false,
  employerDetails: {} as UserEmployerDetails,
  employerDetailsFetched: false,
  userDetailsFetched: false,
  navigationBlockedReason: "",
  enableReallocation: true,
};
